import {EDIT_LOG_UNDO, GET_EDIT_LOG_UNDO, LogEdit } from "../../../Model/Log"

const initState: LogEdit = {
    ResultDtoEdit: null,
    LogEdit: null,
}
//const dispatch = useDispatch();


export const LogUndoEditReducer = (state = initState, action: { type: string, payload: LogEdit }) => {
    switch (action.type) {
        case EDIT_LOG_UNDO:
            {
                return { ...state, ResultDtoEdit: action.payload.ResultDtoEdit }
            }
        case GET_EDIT_LOG_UNDO:
            return { ...state, LogDtoEdit: action.payload.LogEdit }
        default:
            return state;
    }
}